module.exports = __webpack_public_path__ + "img/xlh3.e13a10d3.jpg";